import { render, staticRenderFns } from "./PaginatedList.vue?vue&type=template&id=769dc97c&scoped=true&"
import script from "./PaginatedList.vue?vue&type=script&lang=js&"
export * from "./PaginatedList.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedList.vue?vue&type=style&index=0&id=769dc97c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769dc97c",
  null
  
)

export default component.exports